import React from 'react';
import ToolLayout from '../components/ToolLayout';
import { DollarSign } from 'lucide-react';

/**
 * Standalone Financial & Insurance Summary tool.
 * Binder-safe summary (no account numbers); export to add to your binder.
 */
const FinancialSummaryTool = () => {
  return (
    <ToolLayout
      title="Financial & Insurance Summary"
      description="Binder-safe summary of emergency fund, insurance, and debt overview for your preparedness binder."
      icon={DollarSign}
      guide={{
        intro: 'Create a binder-safe financial snapshot — no account numbers, just the essentials.',
        steps: [
          'Record your emergency fund amount.',
          'List insurance policies by type and company.',
          'Add a high-level debt overview.',
          'Export for your binder.',
        ],
      }}
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <p className="text-muted-foreground">
          Record a high-level financial summary so you can contact banks and insurers after a disaster.
          No account numbers—just policy types, company names, and overview details.
        </p>
        <p className="text-sm text-muted-foreground">
          Full financial summary form and Export coming soon. You can use the Budget tool for emergency fund details and export that for your binder.
        </p>
      </div>
    </ToolLayout>
  );
};

export default FinancialSummaryTool;
